import React from "react";

const LOGO = "https://jewellpaints.com/wp-content/uploads/2026/03/Jewell-paints-logo-1.png";

export function Brand({ dark = false, compact = false }) {
  return (
    <div className="flex items-center gap-2.5" data-testid="brand-logo">
      <img
        src={LOGO}
        alt="Jewell Paints"
        className={compact ? "h-7 w-auto object-contain" : "h-9 w-auto object-contain"}
        onError={(e) => { e.currentTarget.style.display = "none"; e.currentTarget.nextSibling.style.display = "flex"; }}
      />
      <span
        style={{ display: "none" }}
        className={`items-center font-display font-extrabold tracking-tight ${dark ? "text-white" : "text-[#8B0000]"} ${compact ? "text-lg" : "text-xl"}`}
      >
        JEWELL <span className="ml-1 font-light opacity-80">PAINTS</span>
      </span>
      {!compact && (
        <div className={`hidden sm:flex flex-col leading-none border-l pl-2.5 ${dark ? "border-white/20" : "border-gray-200"}`}>
          <span className={`font-display font-bold text-sm ${dark ? "text-white" : "text-gray-900"}`}>REWARDS</span>
          <span className={`text-[10px] ${dark ? "text-white/60" : "text-gray-400"}`}>Powered by channelloyalty.ai</span>
        </div>
      )}
    </div>
  );
}

export function PoweredBy({ className = "" }) {
  return <span className={`text-[11px] text-gray-400 ${className}`}>Powered by <span className="font-semibold text-gray-500">channelloyalty.ai</span></span>;
}
